import React from 'react'

export default function FullWidthImage ({imageUrl}) {

  const style = {backgroundImage: `url(${imageUrl})`}

  return <section className="full-width-image" style={style}></section>

}
